import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApprovalRequestDialogComponent } from './approval-request-dialog.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    ApprovalRequestDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
  ],
  exports:[
    ApprovalRequestDialogComponent
  ]
})
export class ApprovalRequestDialogModule { }
